import React from 'react'

export const Loading = () => (
  <div className="animated fadeIn pt-1 text-center">
    <div className="sk-spinner sk-spinner-pulse" />
  </div>
)
